<div role="main">
	<div class="container-fluid page-contents">
		<div class="row align-items-center">
			<div class="col-12" style="margin-bottom:0.5cm;margin-top:0.5cm" *ngIf="environment.clusterId === 'specialized-prod'">
                <div class="color-alert-critical text-center">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <div class="py-1 legal-alert">
                                To provision Staging please visit https://admin.staging.specialized.com
                            </div>
                        </div>
                    </div>
                </div>
            </div>

			<h2 class="col mb-0" i18n="users page/menu title">Users</h2>
		</div>
		<div class="row">
			<div class="col">
				<hr class="mt-0" />
			</div>
		</div>

		<!-- Search -->
		<div class="row justify-content-center">
			<div class="col-12 col-xl-8">
				<app-users-search-form
					[countries]="countries"
					[genders]="genders"
					[roles]="roles"
					[(valid)]="searchFormValid"
					[(searchFormValues)]="searchFormValues"
					(searchUsers)="search(true, true)"
				></app-users-search-form>
			</div>
		</div>
		<!-- END Search -->

		<!-- Search results -->
		<div class="row user-search-results">
			<div class="col-12">
				<mat-card class="mb-4">
					<div class="table-responsive">
						<table
							mat-table
							[dataSource]="usersService.data.results.results"
							class="w-100"
							matSort
							matSortActive="{{usersService.userSearchQuery.sortColumn}}"
							matSortDisableClear
							matSortDirection="{{usersService.userSearchQuery.sortOrder}}"
							multiTemplateDataRows
							aria-label="List of users found in search"
						>
							<!-- First Name -->
							<ng-container matColumnDef="firstname">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!searchFormValid" i18n>First Name</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<span class="text-capitalize">{{row.firstname.toLowerCase()}}</span>
								</td>
							</ng-container>
							<!-- END First Name -->

							<!-- Last Name -->
							<ng-container matColumnDef="lastname">
								<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!searchFormValid" i18n>Last Name</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<span class="text-capitalize">{{row.lastname.toLowerCase()}}</span>
								</td>
							</ng-container>
							<!-- END Last Name -->

							<!-- Email Column -->
							<ng-container matColumnDef="email">
								<th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n [disabled]="!searchFormValid">Email</th>
								<td mat-cell *matCellDef="let row" class="no-wrap">
									<button title="Copy '{{row.email}}' to clipboard." [appCopyToClipboard]="row.email" [appCopyToClipboardIcon]="true" i18n-title type="button" class="button-link">
										{{ row.email }}
									</button>
								</td>
							</ng-container>
							<!-- END Email Column -->

							<!-- Identities -->
							<ng-container matColumnDef="uuid">
								<th scope="col" mat-header-cell *matHeaderCellDef i18n>UUID</th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									<ng-container *ngFor="let identity of row.identities | keyvalue">
										<div *ngIf="identity.key === 'COGNITO' || identity.key === 'GIGYA'" class="my-1">
														<strong class="text-capitalize"> {{ $any(identity.key) | lowercase}}:</strong>
														<button title="Copy '{{ $any(identity.value) }}' to clipboard." [appCopyToClipboard]="$any(identity.value)" [appCopyToClipboardIcon]="true" i18n-title type="button" class="button-link pl-1">
												{{ identity.value }}
											</button>
										</div>
									</ng-container>
								</td>
							</ng-container>
							<!-- END Identities -->

							<!-- Last Login -->
							<ng-container matColumnDef="lastLogin">
								<th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n [disabled]="!searchFormValid">Last Login<mat-icon
									matTooltip="Date and time displayed using your browser's locale and timezone settings."
									i18n-matTooltip
									class="ml-2 paragraph-icon"
								>info</mat-icon></th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									{{ row.lastLogin | localizedDate }}
								</td>
							</ng-container>
							<!-- END Last Login -->

							<!-- Created -->
							<ng-container matColumnDef="createdTime">
								<th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n [disabled]="!searchFormValid">Created<mat-icon
									matTooltip="Date and time displayed using your browser's locale and timezone settings."
									i18n-matTooltip
									class="ml-2 paragraph-icon"
								>info</mat-icon></th>
								<td mat-cell *matCellDef="let row" class="text-nowrap">
									{{ row.createdTime | localizedDate }}
								</td>
							</ng-container>
							<!-- END Created -->

							<!-- Email Verified -->
							<ng-container matColumnDef="validated">
								<th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n [disabled]="!searchFormValid" class="no-wrap">Verification Status</th>
								<td mat-cell *matCellDef="let row">
									<ng-container *ngIf="row.validated" i18n>Verified</ng-container>
									<ng-container *ngIf="!row.validated" i18n>Unverified</ng-container>
								</td>
							</ng-container>
							<!-- END Email Verified -->

							<!-- Accounts Status -->
							<ng-container matColumnDef="suspended">
								<th scope="col" mat-header-cell *matHeaderCellDef i18n class="no-wrap">Account Status</th>
								<td mat-cell *matCellDef="let row" [attr.data-suspended]="row.suspended">
									<ng-container *ngIf="row.suspended" i18n>Suspended</ng-container>
									<ng-container *ngIf="!row.suspended" i18n>Active</ng-container>
								</td>
							</ng-container>
							<!-- END Accounts Status -->

							<!-- Action Column -->
							<ng-container matColumnDef="action" [stickyEnd]="true">
								<th scope="col" mat-header-cell *matHeaderCellDef class="text-center"></th>
								<td mat-cell *matCellDef="let row; let i = dataIndex" class="actions text-center no-wrap">
									<!-- Action dropdown -->
									<button
										mat-icon-button
										[matMenuTriggerFor]="actionMenu"
										#menuTrigger="matMenuTrigger"
										aria-label="Action menu button"
										title="Available actions"
										i18n-title
										(menuClosed)="openedMenu = null"
										(menuOpened)="openedMenu = i"
										[disabled]="false"
									>
										<mat-icon>more_vert</mat-icon>
									</button>

									<mat-menu #actionMenu="matMenu">
										<button
											mat-menu-item
											i18n
											title="Edit user."
											i18n-title
											(click)="openActionDialog(row, 'editUserAttributes')"
											class="user-action__edit"
										>Edit User</button>
										<button
											mat-menu-item
											i18n
											title="Suspend or unsuspend user."
											i18n-title
											(click)="openActionDialog(row, 'suspendToggle')"
											class="user-action__suspend-toggle"
										>
											<ng-container *ngIf="usersService.data.results.results[i]?.suspended">Unsuspend User</ng-container>
											<ng-container *ngIf="!usersService.data.results.results[i]?.suspended">Suspend User</ng-container>
										</button>
										<!-- TODO See Z5ADM-318 for details -->
										<!-- <button
											mat-menu-item
											i18n
											title="Update user's email."
											i18n-title
											(click)="openActionDialog(row, 'editUserEmail')"
											class="user-action__edit-email"
										>Update Email</button> -->
										<button
											mat-menu-item
											i18n
											title="Verify user email address."
											i18n-title
											(click)="openActionDialog(row, 'verifyEmail')"
											*ngIf="!usersService.data.results.results[i]?.validated"
											class="user-action__verify"
										>Verify Email</button>
										<button
                                            mat-menu-item
                                            i18n
                                            title="Set user's password."
                                            i18n-title
                                            (click)="openActionDialog(row, 'setPassword')"
                                            class="user-action__set-password"
                                        >Set Password</button>
                                        <button
                                            mat-menu-item
                                            i18n
                                            title="Provision Roles."
                                            i18n-title
                                            (click)="openActionDialog(row, 'provisionRoles')"
                                            class="user-action__roles"
                                        >Provision Roles</button>
                                        <button
											mat-menu-item
											i18n
											title="View legals acceptance."
											i18n-title
											(click)="openActionDialog(row, 'termsAcceptance', dialogClass.large)"
											class="user-action__legals"
										>Accepted Legals</button>
										<mat-divider></mat-divider>
										<button
											mat-menu-item
											i18n
											title="Trigger a password reset request."
											i18n-title
											(click)="openActionDialog(row, 'sendResetPasswordEmail')"
											class="user-action__request-password-reset"
										>Request Password Reset</button>
										<button
											mat-menu-item
											i18n
											title="Trigger a verification request."
											i18n-title
											(click)="openActionDialog(row, 'sendVerificationEmail')"
											*ngIf="!usersService.data.results.results[i]?.validated"
											class="user-action__resend-verification"
										>Resend Verification</button>
									</mat-menu>
									<!-- END Action dropdown -->
								</td>
							</ng-container>
							<!-- END Action Column -->

							<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
							<tr
								mat-row
								*matRowDef="let row; columns: tableColumns; let i = dataIndex;"
								class="user--row"
								[ngClass]="{'suspended': row.suspended, 'menuOpen': openedMenu === i}"
							></tr>
						</table>
					</div>
					<mat-paginator
						[length]="usersService.data.results.cnt"
						[pageSize]="usersService.userSearchQuery.pageSize"
						[pageIndex]="usersService.userSearchQuery.pageNumber"
						[pageSizeOptions]="[10, 25, 50]"
						(page)="search()"
						[disabled]="!searchFormValid"
					></mat-paginator>
				</mat-card>
			</div>
		</div>
		<!-- END Search results -->
	</div>
</div>
